import { Check, Copy } from 'lucide-react';
import { useEffect, useState } from 'react';
import { IconButton, cn, toast } from '@orgus/ui';

/** A value to copy: monospace, selectable, with a copy button. */
export function CopyField({ value, label, multiline, className }: { value: string; label: string; multiline?: boolean; className?: string }) {
  const [copied, setCopied] = useState(false);
  useEffect(() => {
    if (!copied) return;
    const t = setTimeout(() => setCopied(false), 1800);
    return () => clearTimeout(t);
  }, [copied]);
  const copy = async () => {
    try {
      await navigator.clipboard.writeText(value);
      setCopied(true);
    } catch (e) {
      toast.error(e);
    }
  };
  return (
    <div className={cn('flex items-start gap-2 rounded-md border border-border bg-bg py-1.5 pl-3 pr-1.5', className)}>
      <code
        aria-label={label}
        className={cn('min-w-0 flex-1 select-all py-0.5 font-mono text-sm leading-relaxed text-fg', multiline ? 'whitespace-pre-wrap break-all' : 'break-all')}
      >
        {value}
      </code>
      <IconButton label={copied ? 'Copied' : `Copy ${label.toLowerCase()}`} icon={copied ? <Check className="text-passed" /> : <Copy />} size="sm" onClick={copy} />
    </div>
  );
}
